import React, { useEffect, useState } from 'react'
import { RotatingLines } from 'react-loader-spinner';
import GoogleMapSearch from '../../../../common/components/google-map-search';
import _ from 'lodash'
import { useNavigate } from 'react-router-dom';
import { cargoLeads } from '../../../../redux/cargo-lead/action';
import { useAppDispatch } from '../../../../hooks/hooks';
import storePersist from '../../../../redux/storePersist';
import { getCardData } from '../../../../common/services/website-card.service';
import { settings } from '../../../../redux/settings/actions';
import { useSelector } from 'react-redux';
import { selectCargoLeadsCreatedItem } from '../../../../redux/cargo-lead/selector';
import { toast } from 'react-toastify';
import useWindowDimensions from '../../../../hooks/useWindowsDimensions';

const CargoMobile = () => {
    let navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { height, width } = useWindowDimensions();
    const [cargoValues, setCargoValues] = useState<any>()
    const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
    const [generateIds, setGenerateIds] = useState<any>([]);
    const leadCreateData = useSelector(selectCargoLeadsCreatedItem)
    const [isLead, setIsLead] = useState<boolean>(false)
    const [searchedLocation, setSearchedLocation] = useState({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: '',
    });

    const [searchedToLocation, setSearchedToLocation] = useState({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: '',
    });

    const handleChange: any = (event: any, field: string) => {
        setCargoValues({ ...cargoValues, [field]: event })
    }
    const generateUniqueId = () => {
        const randomPart = Math.random().toString(36).substr(2, 9); // Random part
        const timestampPart = Date.now().toString(36); // Timestamp part
        return `${randomPart}-${timestampPart}`;
    };

    const generateIdValue = () => {
        const newItem = {
            transaction_id: generateUniqueId(),
            message_id: generateUniqueId(),
        };
        setGenerateIds(newItem);
    };
    const CargoPageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_CARGO_QDP_BANNER') : null;
    const banner = (CargoPageBannerData && CargoPageBannerData[0]?.src ? encodeURI(CargoPageBannerData[0]?.src) : require('./../../../../assets/img/logisticsBanner.png'))

    const handleSubmit = async (event: any) => {

        event?.preventDefault()
        // Validation for required fields
        if (
            !cargoValues?.Email ||
            !cargoValues?.Name ||
            !cargoValues?.PhoneNumber ||
            !cargoValues?.date ||
            !searchedLocation?.description ||
            !searchedToLocation?.description ||
            !cargoValues?.DropName ||
            !cargoValues?.DropPhoneNumber
        ) {
            toast.error("All fields are required. Please fill in all the details.");
            return;
        }

        // Validate phone number length
        if (cargoValues?.PhoneNumber.length < 10 && cargoValues?.DropPhoneNumber.length < 10) {
            toast.error("Please enter a valid phone number with at least 10 digits.");
            return;
        }
        // Validate email format 
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (cargoValues?.Email && !emailRegex.test(cargoValues?.Email)) {
            toast.error("Please enter a valid email address.");
            return;
        }

        const fromAddressData = _.split(searchedLocation?.description, ',');
        const toAddressData = _.split(searchedToLocation?.description, ',');
        try {
            await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
            await setIsButtonLoading(true)
            if (searchedLocation?.description !== searchedToLocation?.description) {
                await dispatch(cargoLeads.create({
                    url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leadCreate', jsonData: {
                        "Records": [
                            {
                                Context: {
                                    transaction_id: generateIds?.transaction_id,
                                    message_id: generateIds?.message_id,
                                },
                                Message: {
                                    LeadInfo: {
                                        Name: cargoValues?.Name,
                                        Email: cargoValues?.Email,
                                        PhoneNumber: cargoValues?.PhoneNumber || '',
                                        date: cargoValues?.date,
                                        Description: '',
                                        IsExistingUser: cargoValues?.IsExistingUser || false,
                                        LeadPayload: {
                                            weight: {
                                                unit: '',
                                                value: 0
                                            },
                                            dimensions: {
                                                length: {
                                                    unit: '',
                                                    value: 0
                                                },
                                                breadth: {
                                                    unit: '',
                                                    value: 0
                                                },
                                                height: {
                                                    unit: '',
                                                    value: 0
                                                }
                                            },
                                            category: '',
                                            value: {
                                                currency: 'INR',
                                                value: 0
                                            },
                                            dangerous_goods: false
                                        },
                                        start: {
                                            location: {
                                                gps: `${searchedLocation?.lat},${searchedLocation?.lng}`,
                                                address: {
                                                    name: cargoValues?.Name,
                                                    building: searchedLocation?.description,
                                                    locality: `${fromAddressData[0]},${fromAddressData[1]}`,
                                                    city: searchedLocation?.name,
                                                    state: fromAddressData[3],
                                                    country: 'India',
                                                    area_code: searchedLocation?.pincode,
                                                },
                                            },
                                            contact: {
                                                phone: cargoValues?.PhoneNumber,
                                                email: cargoValues?.Email
                                            }
                                        },

                                        end: {
                                            location: {
                                                gps: `${searchedToLocation?.lat},${searchedToLocation?.lng}`,
                                                address: {
                                                    name: cargoValues?.DropName,
                                                    building: searchedToLocation?.description,
                                                    locality: `${toAddressData[0]},${toAddressData[1]}`,
                                                    city: searchedToLocation?.name,
                                                    state: toAddressData[3],
                                                    country: 'India',
                                                    area_code: searchedToLocation?.pincode,
                                                },
                                            },
                                            contact: {
                                                phone: cargoValues?.DropPhoneNumber,
                                                email: ""
                                            }
                                        },
                                    }
                                }
                            }
                        ]
                    }
                }))
                await setIsButtonLoading(false)
                await setIsLead(true)
            }

            else {
                setIsButtonLoading(false)
                toast.error("The Pickup and Drop addresses must be different.")
            }
        } catch (error) {
            toast.error("An error occurred while submitting the form. Please try again.");
        }



    }


    useEffect(() => {
        generateIdValue()

    }, [])

    useEffect(() => {
        if (leadCreateData.isSuccess && isLead) {
            dispatch(settings.set({
                cargoLead: cargoValues,
                searchedLocation,
                searchedToLocation,
            }))
            setSearchedLocation({
                name: '',
                lat: '',
                lng: '',
                pincode: '',
                description: '',
            });
            setSearchedToLocation({
                name: '',
                lat: '',
                lng: '',
                pincode: '',
                description: '',
            });
            setCargoValues({
                Name: '',
                Email: '',
                PhoneNumber: '',
                date: '',
                IsExistingUser: '',
            })
            navigate('/auth/login', {
                state:
                    { pageName: 'Cargo' }
            })

            setIsLead(false)
        }
    }, [isLead]);

    return (


        <div className={`max-h-full`}>

            <div className="flex flex-col justify-around items-center w-screen h-full py-20  px-5 " style={{
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className={`w-full my-10 justify-center item-center rounded-xl  bg-white`}>
                    <div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
                        <div className="text-lg text-primary font-bold py-5">Hire Your Truck in a Minute</div>
                        <div className=" w-full px-3 font-bold space-y-2">
                            <div className="flex flex-row ">
                                <div className="w-full text-xs flex flex-row justify-start items-center">
                                    <input
                                        type="checkbox"
                                        name={"from"}
                                        placeholder=""
                                        className={`bg-primary text-xs px-3`}
                                        onChange={(event) => {
                                            handleChange(
                                                event.target.checked,
                                                'IsExistingUser'
                                            )
                                        }}
                                        value={cargoValues?.IsExistingUser}
                                    />
                                    <div className="mx-2">Are You Already Register?</div>
                                </div>
                            </div>
                            <div className="flex flex-row space-x-2 ">
                                <div className=" w-full pt-2">
                                    <div className="font-normal ">
                                        <input
                                            required
                                            type="email"
                                            name={"Email"}
                                            placeholder="Email"
                                            className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                                            onChange={(event) => {
                                                handleChange(
                                                    event.target.value,
                                                    'Email'
                                                );

                                            }}
                                            value={cargoValues?.Email} />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row space-x-2 ">
                                <div className=" w-full pt-2">
                                    <div className="font-normal ">
                                        <GoogleMapSearch
                                            setLocation={setSearchedLocation}
                                            location={searchedLocation}
                                            placeholder="Pickup Address"
                                            required />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row space-x-2 ">
                                <div className=" w-full">

                                    <div className="border-0 font-normal">
                                        <input
                                            required
                                            type="text"
                                            name={"Name"}
                                            placeholder="Name"
                                            className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                                            onChange={(event) => {
                                                handleChange(
                                                    event.target.value,
                                                    'Name'
                                                );
                                            }}
                                            value={cargoValues?.Name} />
                                    </div>
                                </div>
                                <div className=" w-full">

                                    <div className="border-0 font-normal">
                                        <input
                                            required
                                            maxLength={10}
                                            type="text"
                                            name={"PhoneNumber"}
                                            placeholder="Phone Number"
                                            pattern="\d{10}"
                                            className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                                            onChange={(event) => {
                                                handleChange(
                                                    event.target.value.replace(/\D/g, ''),
                                                    'PhoneNumber'
                                                );
                                            }}
                                            value={cargoValues?.PhoneNumber} />
                                        {cargoValues?.PhoneNumber && cargoValues?.PhoneNumber?.length < 10 && (
                                            <span className="text-red-600 text-xs">
                                                Please enter a valid number.
                                            </span>
                                        )}
                                    </div>

                                </div>

                            </div>
                            <div className="flex flex-row space-x-2 ">
                                <div className="w-full">
                                    {/* <label
                                   className="block text-xs font-bold mb-1"
                                   htmlFor="grid-password">
                                   To
                               </label> */}
                                    <div className="font-normal pt-4 ">
                                        <GoogleMapSearch
                                            setLocation={setSearchedToLocation}
                                            location={searchedToLocation}
                                            placeholder="Drop Address"
                                            required />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row space-x-2 ">
                                <div className=" w-full">

                                    <div className="border-0 font-normal">
                                        <input
                                            required
                                            type="text"
                                            name={"DropName"}
                                            placeholder="Name"
                                            className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                                            onChange={(event) => {
                                                handleChange(
                                                    event.target.value,
                                                    'DropName'
                                                );
                                            }}
                                            value={cargoValues?.DropName} />
                                    </div>
                                </div>
                                <div className=" w-full">

                                    <div className="border-0   font-normal">
                                        <input
                                            required
                                            maxLength={10}
                                            type="text"
                                            name={"PhoneNumber"}
                                            placeholder="Phone Number"
                                            pattern="\d{10}"
                                            className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                                            onChange={(event) => {
                                                handleChange(
                                                    event.target.value.replace(/\D/g, ''),
                                                    'DropPhoneNumber'
                                                );
                                            }}
                                            value={cargoValues?.DropPhoneNumber} />
                                        {cargoValues?.DropPhoneNumber && cargoValues?.DropPhoneNumber?.length < 10 && (
                                            <span className="text-red-600 text-xs">
                                                Please enter a valid number.
                                            </span>
                                        )}
                                    </div>
                                </div>

                            </div>
                            <div className="flex flex-row space-x-2 ">
                                <div className=" w-full">

                                    <div className="font-normal ">
                                        <div className="relative w-full">
                                            {/* Label Placeholder */}
                                            <label
                                                htmlFor="frodatem"
                                                className={`absolute top-3 left-3 text-gray-400 pointer-events-none ${cargoValues?.date ? 'hidden' : ''
                                                    }`}
                                            >
                                                Schedule Date & Time
                                            </label>

                                            <input
                                                required
                                                id="frodatem"
                                                type="datetime-local"
                                                min={
                                                    new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                                        .toISOString()
                                                        .slice(0, 16)
                                                }
                                                name="frodatem"
                                                className={`w-full py-3 px-3 border-b-2 border-black text-base ${!cargoValues?.date ? 'text-transparent' : 'text-sky-950'
                                                    }`}
                                                onClick={(event) => {
                                                    const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                                                    input.showPicker(); // Now you can call showPicker() safely
                                                }}
                                                onChange={(event) => handleChange(event.target.value, 'date')}
                                                value={cargoValues?.date}
                                            />
                                        </div>

                                    </div>
                                </div>


                            </div>



                        </div>
                        {/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

                        <div className={`${isButtonLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'} px-5 flex w-full flex-row flex item-center justify-center mt-5 mb-10 `}>
                            <div
                                onClick={!isButtonLoading ? handleSubmit : undefined}

                                className=" flex-row flex items-center justify-center text-light text-base my-3 font-bold cursor-pointer"
                            >
                                Get Quote
                                <div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
                                    <RotatingLines
                                        visible={true}
                                        width={'20'}
                                        strokeColor="#fff"
                                        strokeWidth="6"
                                        animationDuration="0.75"
                                        ariaLabel="rotating-lines-loading"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>






    )
}

export default CargoMobile